import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { InternalLink, LoadingAnimation, SimpleFlexbox, Badge } from 'ctm-components';
import { Dropdown, DropdownItem } from '@comparethemarketau/manor-dropdown';
import classNames from 'classnames';
import { splitTrafficIdSelector } from 'ctm-selectors';
import axios from 'axios';
import { pageContext } from 'ctm-util-functions';
import labelStyles from '../../../ctm-components/components/form/label/label.css';
import { useStyles } from './car_fuel_styles';
import { getFormValue } from '../../core/state_selectors';
import { useStyles as badgeUseStyles } from '../car_badge_unsure/car_badge_button_group_styles';

/**
 * Render the Car Details component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */

const _CarFuel = ({ currentVehicleInfo, splitTrafficId, stageChange, accessToken, journeyUrl, fuelValue, updateStatesResetValues, setManualLookupPayload, env }) => {
    const [fuelType, setFuelTypesReponse] = useState(null);
    const [bodyType, setBodyTypeResponse] = useState(null);
    const [transmissionType, setTransmissionResponse] = useState(null);

    const nextBtn = document.getElementById('car_fuel.nextButton');
    const fuelId = document.getElementById('fuelDropdown');
    const bodyId = document.getElementById('bodyDropdown');
    const transmissionId = document.getElementById('transmissionDropdown');

    useEffect(() => {
        const baseUrl = `${journeyUrl}${env === 'local' ? '' : '/'}`;
        fetchData(`${baseUrl}lookup/manual/${currentVehicleInfo.make}/${currentVehicleInfo.year}/${currentVehicleInfo.model}`, 'fuel');
    }, []);

    const isXS = pageContext.getProps().pageState.breakpoint === 'xs';
    const isFourColumn = pageContext.getProps().pageState.pageName === 'car_fuel';

    const classes = useStyles({ isXS });
    const badgeClasses = badgeUseStyles({ isFourColumn, isXS });

    const fetchData = (requestUrl, id) => {
        axios({
            method: 'get',
            url: requestUrl,
            headers: { Authorization: `Bearer ${accessToken}` }
        })
            .then((response) => {
                if (id === 'fuel') {
                    setFuelTypesReponse(response.data);
                }
                if (id === 'body') {
                    setBodyTypeResponse(response.data);
                }

                if (id === 'transmission') {
                    setTransmissionResponse(response.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    const handleChange = (event, selectedValue, id) => {
        event.persist();
        let requestUrl = '';
        if (id === 'fuel') {
            stageChange(selectedValue, 'coverDetail.vehicle.fuel');
            // reset values
            stageChange(null, 'coverDetail.vehicle.body');
            stageChange(null, 'coverDetail.vehicle.transmission');

            setBodyTypeResponse(null);
            setTransmissionResponse(null);

            // generate new journey request
            requestUrl = `${journeyUrl}/lookup/manual/${currentVehicleInfo.make}/${currentVehicleInfo.year}/${currentVehicleInfo.model}/${selectedValue}`;
            fetchData(requestUrl, 'body');
            setManualLookupPayload(fuelType, 'fuel');

            if (fuelId) {
                fuelId.classList.add('has-value');
                fuelId.classList.remove('error');
            }
        }
        if (id === 'body') {
            stageChange(selectedValue, 'coverDetail.vehicle.body');
            // reset values
            stageChange(null, 'coverDetail.vehicle.transmission');
            setTransmissionResponse(null);
            // generate new request
            requestUrl = `${journeyUrl}/lookup/manual/${currentVehicleInfo.make}/${currentVehicleInfo.year}/${currentVehicleInfo.model}/${
                currentVehicleInfo.fuel
            }/${selectedValue}`;
            fetchData(requestUrl, 'transmission');
            setManualLookupPayload(bodyType, 'bodies');

            if (bodyId) {
                bodyId.classList.add('has-value');
                bodyId.classList.remove('error');
            }
        }

        if (id === 'transmission') {
            stageChange(selectedValue, 'coverDetail.vehicle.transmission');
            setManualLookupPayload(transmissionType, 'transmissions');

            if (transmissionId) {
                transmissionId.classList.add('has-value');
                transmissionId.classList.remove('error');
            }
        }
    };

    const originalFuel = () => {
        return (
            <SimpleFlexbox className={badgeClasses.badge_button_group}>
                {fuelType !== null
                    && fuelType.map((fuel) => {
                        return (
                            <InternalLink className={badgeClasses.badge_button_link} href="/car-insurance/journey/car_body" onClick={() => updateStatesResetValues(fuel.code)}>
                                <Badge
                                    id={fuel.code}
                                    key={fuel.code}
                                    optionProps={{
                                        innerLabel: fuel.label,
                                        value: fuel.code
                                    }}
                                    schema={{
                                        identifier: 'coverDetail.vehicle.fuel',
                                        stateKey: 'vertical.quote.apiResponses.badge.code',
                                        variant: 'center',
                                        field: {
                                            type: 'badgegroup',
                                            metaType: 'radio',
                                            UIComponent: 'badge_primary_semi_rounded',
                                            labelVariant: 'inner_label_container_small_align_left',
                                            values: {
                                                stateKey: 'vertical.quote.apiResponses.fuel',
                                                labelType: 'innerLabel',
                                                labelKey: 'label',
                                                valueKey: 'code',
                                                variant: 'size_xs_50_sm_33'
                                            }
                                        }
                                    }}
                                    value={fuelValue}
                                />
                            </InternalLink>
                        );
                    })}
            </SimpleFlexbox>
        );
    };
    const mvlFuel = () => {
        return (
            <div className={classes.dropdownContainer}>
                {currentVehicleInfo.fuel === null && fuelType === null ? (
                    <div className={classes.mainContainer}>
                        {fetchData(`${journeyUrl}/lookup/manual/${currentVehicleInfo.make}/${currentVehicleInfo.year}/${currentVehicleInfo.model}`, 'fuel')}
                        <LoadingAnimation />
                    </div>
                ) : (
                    <>
                        {fuelType !== null && (
                            <>
                                <p className={classNames(classes.dropdownLabel, labelStyles.variant_multiple_field)}>Fuel type</p>
                                <Dropdown
                                    id={'fuelDropdown'}
                                    key={'fuelDropdown'}
                                    trackingLabel="mvl_fuel"
                                    placeholder="Select"
                                    data-id={'fuelDropdown'}
                                    tooltip={null}
                                    validationMessage={'Please select a fuel type'}
                                    required
                                    handleChange={(event, selectedValue) => {
                                        handleChange(event, selectedValue, 'fuel');
                                    }}
                                    className={currentVehicleInfo?.fuel ? classes.active : classes.dropdown}
                                    selectedValue={currentVehicleInfo?.fuel}
                                >
                                    {fuelType?.map((fuel) => {
                                        return (
                                            <DropdownItem data-id={fuel.code} className={classes.dropdownItem} key={fuel.code} value={fuel.code}>
                                                {fuel.label}
                                            </DropdownItem>
                                        );
                                    })}
                                </Dropdown>
                            </>
                        )}
                    </>
                )}

                {currentVehicleInfo.fuel !== null && bodyType === null ? (
                    <div className={classes.mainContainer}>
                        {fetchData(
                            `${journeyUrl}/lookup/manual/${currentVehicleInfo.make}/${currentVehicleInfo.year}/${currentVehicleInfo.model}/${currentVehicleInfo.fuel}`,
                            'body'
                        )}
                        <LoadingAnimation />
                    </div>
                ) : (
                    <>
                        {fuelType !== null && bodyType !== null && (
                            <>
                                <p className={classes.dropdownLabel}>Body type</p>
                                <Dropdown
                                    id={'bodyDropdown'}
                                    key={'bodyDropdown'}
                                    data-id={'bodyDropdown'}
                                    trackingLabel="mvl_body"
                                    placeholder={'Select'}
                                    tooltip={null}
                                    required
                                    validationMessage={'Please select a body type'}
                                    className={currentVehicleInfo?.body ? classes.active : classes.dropdown}
                                    handleChange={(event, selectedValue) => {
                                        handleChange(event, selectedValue, 'body');
                                    }}
                                    selectedValue={currentVehicleInfo?.body}
                                >
                                    {currentVehicleInfo?.fuel
                                        && fuelType !== null
                                        && bodyType !== null
                                        && bodyType.length > 0
                                        && bodyType.map((body) => {
                                            return (
                                                <DropdownItem data-id={body.code} className={classes.dropdownItem} key={body.code} value={body.code}>
                                                    {body.label}
                                                </DropdownItem>
                                            );
                                        })}
                                </Dropdown>
                            </>
                        )}
                    </>
                )}
                {currentVehicleInfo.fuel !== null && currentVehicleInfo.body !== null && transmissionType === null ? (
                    <div className={classes.mainContainer}>
                        {fetchData(
                            `${journeyUrl}/lookup/manual/${currentVehicleInfo.make}/${currentVehicleInfo.year}/${currentVehicleInfo.model}/${currentVehicleInfo.fuel}/${
                                currentVehicleInfo.body
                            }`,
                            'transmission'
                        )}
                        <LoadingAnimation />
                    </div>
                ) : (
                    <>
                        {fuelType !== null && bodyType !== null && transmissionType !== null && (
                            <>
                                <p className={classes.dropdownLabel}>Transmission type</p>
                                <Dropdown
                                    id={'transmissionDropdown'}
                                    key={'transmissionDropdown'}
                                    data-id={'transmissionDropdown'}
                                    trackingLabel="mvl_transmission"
                                    placeholder={'Select'}
                                    tooltip={null}
                                    validationMessage={'Please select a transmission type'}
                                    required
                                    className={currentVehicleInfo?.transmission ? classes.active : classes.dropdown}
                                    handleChange={(event, selectedValue) => {
                                        handleChange(event, selectedValue, 'transmission');
                                    }}
                                    selectedValue={currentVehicleInfo?.transmission}
                                >
                                    {currentVehicleInfo?.fuel
                                        && currentVehicleInfo?.body
                                        && bodyType !== null
                                        && transmissionType !== null
                                        && transmissionType.length > 0
                                        && transmissionType.map((transmission) => {
                                            return (
                                                <DropdownItem data-id={transmission.code} className={classes.dropdownItem} key={transmission.code} value={transmission.code}>
                                                    {transmission.label}
                                                </DropdownItem>
                                            );
                                        })}
                                </Dropdown>
                            </>
                        )}
                    </>
                )}
            </div>
        );
    };
    if (nextBtn) {
        if (currentVehicleInfo.transmission === null) {
            nextBtn.style.pointerEvents = 'none';
            nextBtn.style.background = '#b7e8c9';
            nextBtn.style.opacity = '0.6';
            nextBtn.style.color = '#333333';
        }

        if (currentVehicleInfo.transmission !== null) {
            nextBtn.style.pointerEvents = 'auto';
            nextBtn.style.background = '#0db14b';
            nextBtn.style.opacity = '1';
            nextBtn.style.color = 'white';
        }

        nextBtn.parentNode.addEventListener('click', () => {
            if (fuelId && currentVehicleInfo.fuel === null && !fuelId.classList.contains('has-value')) {
                fuelId.classList.add('error');
            }
            if (bodyId && currentVehicleInfo.body === null && !bodyId.classList.contains('has-value')) {
                bodyId.classList.add('error');
            }
            if (transmissionId && currentVehicleInfo.transmission === null && !transmissionId.classList.contains('has-value')) {
                transmissionId.classList.add('error');
            }
        });
    }
    return <div className={classes.mainContainer}>{splitTrafficId === 'mvlTest2' ? mvlFuel() : originalFuel()}</div>;
};

const mapDispatchToProps = (dispatch) => ({
    updateStatesResetValues: (code) => {
        dispatch({
            type: 'SET_FORM_VALUE',
            value: code,
            stateKey: 'vertical.quote',
            identifier: 'coverDetail.vehicle.fuel'
        });
        dispatch({
            type: 'RESET_VALUES',
            stateKey: 'vertical.quote',
            identifiers: [
                'coverDetail.vehicle.body',
                'coverDetail.vehicle.transmission',
                'coverDetail.vehicle.badge',
                'coverDetail.vehicle.colour',
                'coverDetail.vehicle.redbookCode',
                'coverDetail.vehicle.redbookCodeLong',
                'coverDetail.vehicle.nviCode',
                'coverDetail.vehicle.glassCode',
                'coverDetail.vehicle.marketValue',
                'coverDetail.vehicle.alarmFitted',
                'coverDetail.vehicle.immobiliserFitted',
                'coverDetail.vehicle.securityFeatures',
                'coverDetail.vehicle.factoryOptions',
                'coverDetail.vehicle.nonStandardAccessories'
            ]
        });
        dispatch({
            type: 'RESET_TOUCHES',
            stateKey: 'vertical.quote',
            identifiers: ['coverDetail.vehicle.body']
        });
    },
    stageChange: (code, identifier) => {
        dispatch({
            type: 'SET_FORM_VALUE',
            value: code,
            stateKey: 'vertical.quote',
            identifier
        });
    },
    setManualLookupPayload: (payload, identifier) => {
        dispatch({
            type: 'SET_MANUAL_LOOKUP_PAYLOAD',
            payload,
            identifier
        });
    }
});
/**
 * Map state to our component props
 * @param {Object} state - the application state
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state) => {
    let fuelTypes = state.getIn(['vertical', 'quote', 'apiResponses', 'fuel']);
    fuelTypes = fuelTypes ? JSON.parse(JSON.stringify(fuelTypes)) : [];
    let currentVehicleInfo = state.getIn(['vertical', 'quote', 'form', 'coverDetail', 'vehicle']);
    currentVehicleInfo = currentVehicleInfo ? JSON.parse(JSON.stringify(currentVehicleInfo)) : [];
    const currentFuel = state.getIn(['vertical', 'quote', 'form', 'coverDetail', 'vehicle', 'fuel']);
    const splitTrafficId = splitTrafficIdSelector(state);
    const fuelValue = getFormValue(state, 'coverDetail.vehicle.fuel');

    return {
        fuelTypes,
        currentVehicleInfo,
        splitTrafficId,
        accessToken: state.getIn(['user', 'tokens', 'access_token']),
        journeyUrl: state.getIn(['serverConfig', 'journeyServiceBaseUrl']),
        currentFuel,
        fuelValue,
        env: state.getIn(['serverConfig', 'env'])
    };
};

const CarFuel = connect(
    mapStateToProps,
    mapDispatchToProps
)(_CarFuel);

export { CarFuel, _CarFuel };
